import { Modal } from "@mui/material";
import { LuShieldAlert, LuX } from "react-icons/lu";
import "./appmodal.css";

function AppModal({
  open,
  closeModalClick,
  handleCancel,
  message = "You are not authorised to access this screen.",
  title = "Access restricted",
  actionLabel = "Got it",
}) {
  const close = handleCancel || closeModalClick;

  return (
    <Modal
      open={Boolean(open)}
      onClose={closeModalClick || handleCancel}
      aria-labelledby="access-dialog-title"
      aria-describedby="access-dialog-description"
      className="access-dialog-modal"
      slotProps={{ backdrop: { className: "access-dialog-backdrop" } }}
    >
      <section
        className="access-dialog"
        role="alertdialog"
        aria-labelledby="access-dialog-title"
        aria-describedby="access-dialog-description"
      >
        <header className="access-dialog-header">
          <span className="access-dialog-icon" aria-hidden="true">
            <LuShieldAlert />
          </span>
          <h2 id="access-dialog-title">{title}</h2>
          <button
            type="button"
            className="access-dialog-close"
            aria-label="Close access message"
            onClick={closeModalClick || handleCancel}
          >
            <LuX />
          </button>
        </header>
        <div className="access-dialog-content">
          <p id="access-dialog-description">{message}</p>
        </div>
        <footer className="access-dialog-actions">
          <button type="button" onClick={close}>
            {actionLabel}
          </button>
        </footer>
      </section>
    </Modal>
  );
}

export default AppModal;
